export default "__VITE_ASSET__D9dV2d1A__"